import React from 'react';
import PropTypes from 'prop-types';
import {compose, withStateHandlers} from 'recompose';
import {FormattedMessage} from 'react-intl';
import VideoModal from 'modules/common/VideoModal';
import NewDesignButton from 'modules/common/NewDesignButton';
import {mhBox, trackCourseButtonWidth} from './style.scss';

const TrackTrailer = ({
  trailerYoutubeId,
  toggleTrailer,
  trackName,
  trailerOn,
}) => {
  return (
    <div
      className={`flex flex-column justify-between ${mhBox} bg-white ba b--light-gray bw1 br2 tc`}
    >
      <h2 data-cy="course-name" className="pt4 pb2 f5">
        <FormattedMessage id="track_trailer" />
      </h2>
      <p className="gray lh-copy ph3 pb5 pt4">
        <FormattedMessage id="track_trailer_description" />
      </p>
      <div className="pv4 bg-near-white">
        <div className="pa3">
          <NewDesignButton
            className={`ph4 pv2 f6 lh-copy bg-blue bg-animate hover-bg-dark-blue ${trackCourseButtonWidth}`}
            onClick={toggleTrailer}
          >
            <FormattedMessage id="view_trailer" />
          </NewDesignButton>
        </div>
      </div>
      {trailerOn && (
        <VideoModal
          rightButtonClick={toggleTrailer}
          videoId={trailerYoutubeId}
          title={trackName}
        />
      )}
    </div>
  );
};

TrackTrailer.propTypes = {
  trailerYoutubeId: PropTypes.string.isRequired,
  trackName: PropTypes.string.isRequired,
};

const enhance = compose(
  withStateHandlers(
    {
      trailerOn: false,
    },
    {
      toggleTrailer: ({trailerOn}) => () => {
        return {
          trailerOn: !trailerOn,
        };
      },
    },
  ),
);

export default enhance(TrackTrailer);
